import { render, staticRenderFns } from "./StockItemsTab.vue?vue&type=template&id=2ce05c41&"
import script from "./StockItemsTab.vue?vue&type=script&lang=js&"
export * from "./StockItemsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports